import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {Layout,Button, Typography,Card,Form,Input,Checkbox,message, Alert, notification,Spin, Divider, Row, Col} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { InfoCircleOutlined } from '@ant-design/icons';
import greenbg from "../../assets/images/greenw.png";


const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function SignUp () {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const formRef = React.createRef();
  const navigate = useNavigate();
  
  const [notificationApi, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (notificationType, title, content) => {
    notificationApi.error({
      message: title,
      description: content,
      duration: 0,
      placement:'bottomLeft'
    });
  };
  
  const onReset = () => {
    formRef.current.resetFields();
  };
  const sendRequest = (formValue) => {
    const { BusinessMobile,BusinessName,Membername, email, password } = formValue;
    setLoading(true);
    let headersList = {
    "accept": "*/*",
    "Content-Type": "application/json" 
    //"authentication"
    }

    let reqOptions = {
      url: `${process.env.REACT_APP_BASE_URL}client/create`,
      method: "POST",
      headers: headersList,
      data: JSON.stringify({
        clientName: BusinessName,
        clientPassword: password,
        contactPerson: Membername,
        merchantNumber: BusinessMobile,
        clientEmail: email}),
    }
    axios.request(reqOptions).then(function (response) {
      setLoading(false);
      message.success("successfully created a new account. You may now log in")
      onReset();
      navigate('/SignUpSuccess');
    }).catch((error) => {
    message.error(error.response.data??"Unexpected error. "+error.message);
    openNotificationWithIcon("error", "Error", error.response.data??error.message);
    setLoading(false);
    }) 
}
    const onFinishFailed = (errorInfo) => {
      message.error("Please fill the form correctly before submitting...");
    };

    return (
      <>
        <div className="layout-default ant-layout layout-sign-up" style={{with:'100%', backgroundImage: `url(${greenbg})`, backgroundSize: 'auto !important'}} ref={element => { 
         if (element) element.style.setProperty('backgroung-image', `url(${greenbg})`, '!important'); 
       }}>
          <Content className="p-0">
            <Card style={{margin:'13% 2%', width:'100vw'}}
              className="card-signup header-solid h-full ant-card pt-0"
              title={<h5 style={{color:'green'}}>Create C-Pay API Management Account</h5>}
              bordered="false"
            >
              <hr/>
              <Spin spinning={loading} delay={5000} size='default' tip='Registering... Please wait!'>
              <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={sendRequest}
                onFinishFailed={onFinishFailed}
                className="row-col"
                onReset={onReset}
                ref={formRef}
                layout="vertical">

                 <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={12}>
                <Form.Item
                  label="Business Name"
                  name="BusinessName"
                  tooltip={{ title: 'A valid desired Merchant Name', icon: <InfoCircleOutlined />}}
                  rules={[{ required: true,
                     message: <Alert  style={{margin:5}} message='please enter Business Name' type="error" showIcon /> },{
                     pattern: /^[A-Za-z][A-Za-z0-9_ ]{3,29}$/,
                     message: <Alert  style={{margin:5}}message='please a enter a valid Business Name' type="error" showIcon />,
                 }]} hasFeedback>
                  <Input placeholder="Business Name" />
                </Form.Item>

                <Form.Item
                  label="Business Mobile"
                  name="BusinessMobile"
                  tooltip={{ title: 'Mobile phone to be associated with your merchant account', icon: <InfoCircleOutlined />}}
                  hasFeedback
                  rules={[
                    { required: true, message: <Alert  style={{margin:5}}message="Please input your Business Mobile Number!" type="error" showIcon /> },{
                      pattern: /^[0-9]{8,10}$/,
                      message: <Alert  style={{margin:5}}message='please a enter a valid Mobile Number' type="error" showIcon />,
                  }
                  ]}>
                  <Input placeholder="Business Mobile Number" />
                </Form.Item>

                <Form.Item
                  label="Member Names"
                  name="Membername"
                  tooltip={{ title: 'Business Representative', icon: <InfoCircleOutlined />}}
                  hasFeedback
                  rules={[
                    { required: true, message: <Alert  style={{margin:5}}message='please a enter a member Name' type="error" showIcon /> },{
                      pattern: /^[A-Za-z][A-Za-z0-9_ ]{3,29}$/,
                      message: <Alert  style={{margin:5}}message='please a enter a valid member Name' type="error" showIcon />,
                  }
                  ]}>
                  <Input placeholder="Business Member name"/>
                </Form.Item>
                </Col>

                <Col span={12} border="1px inset">

                <Form.Item
                  label="E-Mail"
                  name="email"
                  hasFeedback
                  rules={[
                    { required: true, message: <Alert  style={{margin:5}}message="Please input your email!" type="error" showIcon /> },{
                      pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                      message: <Alert  style={{margin:5}}message='please a enter a valid email' type="error" showIcon />,
                     }
                  ]}>
                  <Input placeholder="email" />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  hasFeedback
                  rules={[
                    { required: true, message:<Alert  style={{margin:5}}message="Please input your password!" type="error" showIcon /> },
                  ]}
                >
                  <Input.Password placeholder="Enter your password here"/>
                </Form.Item>

                <Form.Item
                    label="Confirm Password"
                    name="confirm"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                    {
                        required: true,
                        message: <Alert  style={{margin:5}}message='please confirm your password' type="error" showIcon />,
                    },
                    ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                        }
                        return Promise.reject(new Error('Two passwords do not match'));
                        },
                    }),
                    ]}
                >
                <Input.Password  placeholder='Retype the password'/>
                </Form.Item>
                </Col>
                </Row>

                <Form.Item name="remember" valuePropName="checked" rules={[{ required: true, message: 'Please agree to the terms first' }]}>
                  <Checkbox>
                    I agree the{" "}
                    <a href="#termsncs" className="font-bold text-dark">
                      Terms and Conditions
                    </a>
                  </Checkbox>
                </Form.Item>

                <Form.Item>
                {loading?<Button shape="round" style={{ width: "100%",backgroundColor:'white',border:'1px solid #00b33c' }} disabled ><Spin/></Button>:<Button
                      htmlType="submit"
                      style={{ width: "100%",backgroundColor:'#00b33c',color:'white' }}
                    >
                      SIGN UP
                    </Button>}
                </Form.Item>
              </Form>
              </Spin>
              <p className="font-semibold text-muted text-center">
                Already have an account?{" "}
                <Link to="/SignIn" className="font-bold text-dark">
                  Sign In
                </Link>
              </p>
            </Card>
            {contextHolder}
          </Content>
        </div>
      </>
    );
  }

